const zh = {
  nav: {
    home: "首页",
    exams: "考卷设计",
    math: "数学模块",
    favorites: "收藏夹",
    history: "答题历史",
  },
  home: {
    hero_tag: "欢迎来到 EduLeaf",
    hero_title: "每日成长，",
    hero_title_accent: "学无止境",
    hero_sub: "面向小学到大学生的 AI 智能学习工具，家长和学生都能轻松使用。",
    cta_exam: "开始考卷模块",
    cta_math: "探索数学模块",
    modules_title: "学习模块",
    modules_sub: "两个强大的学习模块，助你学得更聪明、成长更快速。",
    module1_title: "考卷设计",
    module1_desc: "为西班牙语、德语、英语 PTE 生成 AI 智能考卷。上传文件或选择难度等级，一键生成。",
    module1_tag: "AI 驱动",
    module2_title: "数学模块",
    module2_desc: "对应新西兰课程大纲（Year 1–13）的数学练习题，结构清晰，层层递进。",
    module2_tag: "新西兰课程",
    stats_exams: "已生成考卷",
    stats_subjects: "支持科目",
    stats_students: "服务学生",
    how_title: "使用步骤",
    how_sub: "三步轻松开始智慧学习。",
    step1_title: "选择科目",
    step1_desc: "选择西班牙语、德语、英语 PTE 或数学。",
    step2_title: "生成考卷",
    step2_desc: "上传文件或让 AI 按难度自动生成。",
    step3_title: "答题与记分",
    step3_desc: "完成考卷，核对答案，收藏重点题目。",
  },
  exam: {
    title: "考卷模块",
    choose_subject: "选择科目",
    subject_sub: "选择一个科目开始。上传资料或按等级自动生成考卷。",
    spanish: "西班牙语",
    german: "德语",
    english: "英语",
    generate_from_file: "上传文件生成",
    auto_generate: "AI 自动生成",
    upload_title: "上传你的文件",
    upload_desc: "拖放或点击上传 PDF、Word 或图片文件。AI 将自动扫描内容并生成定制考卷。",
    upload_btn: "选择文件",
    upload_hint: "支持 PDF、DOCX、JPG、PNG，最大 20 MB",
    generate_btn: "生成考卷",
    generating: "考卷生成中……",
    levels: "选择难度等级",
    beginner: "初级",
    intermediate: "中级",
    advanced: "高级",
    dashboard_title: "我的学习看板",
    dashboard_sub: "追踪学习进度，复习往次考卷，查看收藏题目。",
    history_title: "答题记录",
    history_empty: "暂无答题记录，快去生成你的第一份考卷吧！",
    favorites_title: "我的收藏",
    favorites_empty: "暂无收藏题目，点击题目旁的星号即可收藏。",
    favorites_empty_hint: "随时查看你收藏的题目，方便复习。",
    score_label: "得分",
    date_label: "日期",
    questions_label: "题数",
    review_btn: "复习",
    take_exam_btn: "🔄 清零并重做",
  },
  exam_page: {
    multiple_choice: "选择题",
    fill_in: "填空题",
    true_false: "判断题",
    translation: "翻译题",
    verify_section: "验证本节",
    submit_exam: "提交考卷",
    favorite: "收藏",
    unfavorite: "取消收藏",
    answer_correct: "正确！",
    answer_wrong: "错误",
    score_result: "你的得分",
    total_score: "总分",
    out_of: "（满分 100 分）",
    listen_btn: "播放",
    question: "第",
    your_answer: "你的答案",
    model_answer: "参考答案",
  },
  math: {
    title: "数学模块",
    subtitle: "选择课程体系",
    desc: "请选择您就读的教育体系以开始数学练习。",
    system_ncea: "NZ NCEA",
    system_ncea_desc: "新西兰国家教育成绩证书",
    system_cambridge: "Cambridge International",
    system_cambridge_desc: "剑桥 A-Level / IGCSE 课程",
    system_ib: "International Baccalaureate",
    system_ib_desc: "IB 国际文凭课程",
    primary: "小学",
    intermediate: "初中",
    secondary: "高中",
    year: "Year",
    coming_soon: "即将上线",
    coming_desc: "该年级的丰富练习题正在开发中，敬请期待！",
    template_note: "本模块即将推出完整练习内容。",
    tab_overview: "学习路线与目标",
    tab_topics: "核心考点与外部资源",
    tab_papers: "历年真题库",
  },
  common: {
    back: "返回",
    loading: "加载中……",
    error: "出现错误，请重试。",
    save: "保存",
    cancel: "取消",
    confirm: "确认",
    close: "关闭",
    search: "搜索",
    language: "English",
  },
};

export default zh;
